import { useTranslation } from "@opendash/core";
import { ColorPicker } from "@opendash/ui";
import { Button, Drawer, Form, Input, Space, Switch } from "antd";
import TextArea from "antd/lib/input/TextArea";
import * as React from "react";
import { useState } from "react";
import { Kanban_State } from "../../../../js/parsegenerated";

export const KanbanCreateDrawer = (props: {
  open: boolean;
  onCancel: Function;
  onOk: Function;
}) => {
  const t = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState<string>("#000000");

  const onClose = () => {
    props.onCancel();
    form.resetFields();
  };

  const onSave = () => {
    setLoading(true);
    form.validateFields().then(
      async (values: any) => {
        const monitorstate: Kanban_State = new Kanban_State();

        monitorstate.set("color", values.color);
        monitorstate.set("description", values.description);
        monitorstate.set("isFinished", values.isFinished);
        monitorstate.set("isInbox", values.isInbox);
        monitorstate.set("label", values.label);
        monitorstate.set("order", 99);

        await monitorstate.save();
        props.onOk();
        setLoading(false);
        form.resetFields();
      },
      (errors): void => {
        console.log(errors);
        setLoading(false);
      }
    );
  };

  return (
    <>
      <Drawer
        title={t("maintenance:monitor.create.headline")}
        placement="bottom"
        height={"70%"}
        onClose={onClose}
        open={props.open}
        extra={
          <Space>
            <Button onClick={onClose}>
              {t("maintenance:global.button.cancel_label")}
            </Button>
            <Button type="primary" onClick={onSave} loading={loading}>
              {t("maintenance:global.button.save_label")}
            </Button>
          </Space>
        }
      >
        <Form layout="vertical" form={form}>
          <Form.Item
            label={t("maintenance:monitor.create.form.label.label")}
            name="label"
            rules={[
              {
                required: true,
                message: t(
                  "maintenance:monitor.create.form.label.rules.required"
                ),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t("maintenance:monitor.create.form.description.label")}
            name="description"
          >
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item
            label={t("maintenance:monitor.create.form.isInbox.label")}
            name="isInbox"
            valuePropName="checked"
          >
            <Switch
              checkedChildren={t(
                "maintenance:monitor.create.form.isInbox.checked"
              )}
              unCheckedChildren={t(
                "maintenance:monitor.create.form.isInbox.unchecked"
              )}
            />
          </Form.Item>
          <Form.Item
            label={t("maintenance:monitor.create.form.isFinished.label")}
            name="isFinished"
            valuePropName="checked"
          >
            <Switch
              checkedChildren={t(
                "maintenance:monitor.create.form.isFinished.checked"
              )}
              unCheckedChildren={t(
                "maintenance:monitor.create.form.isFinished.unchecked"
              )}
            />
          </Form.Item>
          <Form.Item
            label={t("maintenance:monitor.create.form.color.label")}
            name="color"
          >
            <ColorPicker
              value={color}
              onChange={(value) => {
                setColor(value);
              }}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};
